import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Icon } from '../../component-icon';
import { forwardRef } from 'react';
/**
 * Should be used to render icons within the breadcrumbs. It supports all `Icon` props.
 */
export const BreadcrumbIcon = forwardRef((props, ref) => (_jsx(Icon, { size: "sm", color: "surface-ui-default", emphasis: "medium", ...props, ref: ref })));
BreadcrumbIcon.displayName = 'BreadcrumbIcon';
